<template>
    <div class="sort-box">
        <div class="header-sort">
            <h3>Sort by</h3>

            <button @click="shwoHideSort()">
                <i class="fa fa-close"></i>
            </button>
        </div>
        <div class="inner-sort">
            <div v-for="(item, index) in settingsSort" v-bind:key="index" :data-sort-id="item.column" @click="changeSort(item.column)" :class="['row-sort']">
                <span>{{item.label}}</span>

                <div class="sort-wrapper">
                    <button v-if="sortMobile.column == item.column && sortMobile.direction == false"><img src="../assets/img/sort-asc.svg" /> Ascend.</button>
                    <button v-if="sortMobile.column == item.column && sortMobile.direction == true"><img src="../assets/img/sort-desc.svg" /> Desc.</button>
                </div>
            </div>
        </div>

        <div class="bottom-buttons">
            <div class="left-side">
                <button @click="clearAllSort()" class="btn btn-default">Clear All</button>
            </div>
            <div class="right-side">
                <button @click="shwoHideSort()" class="btn btn-default">Cancel</button>
                <button @click="acceptSortMobile()" class="btn btn-success">Apply</button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'FTSSort',
    data() {
        return {
            sortMobile: {
                column: 0,
                direction: false
            },
            toggleSort: false,
        }
    },
    props: {
        visibleSort: Boolean,
        directionSort: Boolean,
        columnSort: Number,
        settingsSort: Array,
    },
    methods: {
        changeSort(columnNumber) {
            if (columnNumber == this.sortMobile.column) {
                this.sortMobile.direction = (this.sortMobile.direction == true) ? false : true;
            } else {
                this.sortMobile.column = columnNumber;
                this.sortMobile.direction = false;
            }
        },
        acceptSortMobile() {
            this.$emit('submitSort', this.sortMobile);
            this.$emit('hideSort');
        },
        clearAllSort() {
            this.sortMobile.direction = false;
            this.sortMobile.column = 0;
        },
        shwoHideSort() {
            this.$emit('hideSort')
        },

    },
    mounted() {
        this.sortMobile.column = this.columnSort;
        this.sortMobile.direction = this.directionSort;
    }
}
</script>

<style lang="scss">
.sort-box {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    padding-top: 55px;
    background-color: #fff;
    z-index: 3090;

    .header-sort {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 16px;
        border-bottom: 1px solid #CCCCCC;

        h3 {
            margin: 0;
            font-size: 15px;
            font-weight: 700;
        }

        button {
            padding: 0;
            background-color: transparent;
            border: 0;

            i {
                margin: 0;
                font-size: 20px;
            }
        }
    }

    .inner-sort {
        .row-sort {
            height: 49px;
            padding: 12px 16px;
            display: flex;
            justify-content: space-between;
            cursor: pointer;

            button {
                padding: 0;
                background-color: transparent;
                border: 0;
            }
        }
    }

    .bottom-buttons {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: space-between;
        padding: 16px;
        background-color: #F9F9F9;

        button {
            background-color: #F2F2F2;
        }

        .right-side {
            display: flex;

            button {
                white-space: nowrap;
                margin-left: 10px;
                background-color: #F2F2F2;

                &.btn-success {
                    background-color: #55CD6C;
                }
            }
        }
    }
}

.dark-theme {
    .sort-box {
        background-color: #3A4149;
        color: #EDEEEF;

        .header-sort {
        border-color: #1a1c1d;
        }

        .inner-sort .row-sort button {
        color: #EDEEEF;
        }

        .bottom-buttons {
            background-color: #2f353a;
        }
    }
}

// border: #1a1c1d
// bg: rgba(0, 0, 0, 0.6)
// color: #EDEEEF
// active: #00b1ff
</style>
